module.exports = __webpack_public_path__ + "static/open-sans-v27-latin-700-3d1b06f2d8f36c86fa679ff135335fa3.woff";